import { IProjectsGetResponse } from 'shared/repositories/promotions-flow-control/entities/projects/ProjectsGetResponse';
import { TProjectsList } from 'shared/types/project';

export function prepareProjects(response: IProjectsGetResponse): TProjectsList {
  const { projects, total } = response;

  return {
    total,
    projects: projects.map(
      ({ project: { description, seoDescription, ...rest }, isActive, hash, configCreatedAt }) => ({
        ...rest,
        description: description || '',
        seoDescription: seoDescription || '',
        published: isActive,
        hash: hash || undefined,
        configCreatedAt,
      }),
    ),
  };
}
